import React, { Component } from 'react';
import classNames from 'classnames';

class Checkbox extends Component {

  state = {
    isChecked: this.props.checked || false
  }

  handleClick = (e) => {
    const isChecked = !this.state.isChecked;
    const { onClick } = this.props;
    this.setState({ isChecked });
    if (typeof onClick === 'function') {
      onClick(e);
    }
  }

  handleContainerClick = () => {
    const isChecked = !this.state.isChecked;
    const { onClick } = this.props;
    this.setState({ isChecked });
    if (typeof onClick === 'function') {
      onClick({ target: { checked: isChecked } });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.checked) !== this.props.checked) {
      this.setState({ isChecked: this.props.checked });
    }
  }

  render() {
    const {
      id,
      children,
      className,
      ...rest
    } = this.props;

    const { isChecked } = this.state;

    return <div className='pf-checkbox-wrapper'>
      <div
        onClick={this.handleContainerClick}
        className={classNames('pf-checkbox-container', className, {
          'pf-checkbox-container--selected': isChecked
      })}>
      <div className='check'></div>
      <input
        id={id}
        checked={isChecked}
        type='checkbox'
        onClick={this.handleClick}
        {...rest}
        />
      </div>
      { children && <div className='pf-checkbox-label-container'><label htmlFor={id}>{children}</label></div> }
    </div>;
  }
}

export default Checkbox;

